import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';

const FormContainer = styled.div`
  flex:1
`;

const TextFieldContainer = styled.div`
  color: rgba(52,92,68,255);
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 60px;
  max-height: 60px;
`;

const StyledTextField = styled(TextField)({
  '& .MuiInput-underline': {
    '&:before': {
      borderBottom: '1px solid rgba(52,92,68,255)',
    },
    '&:hover:not($disabled):not($focused):not($error):before': {
      borderBottom: '1px solid rgba(52,92,68,255)',
    },
    '&:after': {
      borderBottom: '1px solid rgba(52,92,68,255)',
    },
  },
  '& .MuiFormLabel-root': {
    color: 'rgba(52,92,68,255)',
  },

  '& .MuiFormLabel-root.Mui-error': {
    color: ' rgba(52,92,68,255) !important',
  },
  '& .MuiInput-underline.Mui-error:after': {
    borderBottomColor: 'rgba(52,92,68,255) !important',
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: '#CCD5D5 !important',
  },
  '& .MuiFormLabel-root.Mui-focused': {
    color: 'rgba(52,92,68,255)',
  },

});

export {
  FormContainer,
  TextFieldContainer,
  StyledTextField,
};
